import { render, staticRenderFns } from "./SellAmountPlus.vue?vue&type=template&id=c2650098&scoped=true"
import script from "./SellAmountPlus.vue?vue&type=script&lang=js"
export * from "./SellAmountPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2650098",
  null
  
)

export default component.exports